module.exports = __webpack_public_path__ + "static/img/theme_list_icon03.14ad8dbf.svg";